import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { notification } from 'redux/modules/app'
import { leaders as leadersApi } from 'redux/modules/api'
import { checkEmail } from 'redux/modules/api/asyncValidations'
import { leaderScheme } from 'models'
import config from 'config'


function decorator() {
  return ComposedComponent => {
    @connect(({ api, apiV2, app }) => ({
      leaders: api.leaders,
      configuration: apiV2.configuration,
      localeId: app.locale.id
      // Configuration actions are intentionally not injected here
    }), { ...leadersApi, notification, push, checkEmail })

    class Leaders extends Component {
      static propTypes = {
        localeId: PropTypes.number.isRequired,
        checkEmail: PropTypes.func.isRequired,
        createLeader: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
      }

      handleLeaderCreate = fields => {
        const { localeId, configuration } = this.props
        this.props.createLeader(leaderScheme(fields, localeId, configuration))
          .then(this.handleCreateSuccess)
          .catch(this.handleError)
      }

      handleCheckEmail = params => this.props.checkEmail(params).then(({ body }) => body || false)

      handleCreateSuccess = () => {
        this.props.notification('Leader has been created', {
          status: 'success',
          intlKey: 'notifications.leader_has_been_created'
        })
        this.props.push(`${config.publicPath}/register/leader/success`)
        return 'success'
      }

      handleError = err => {
        console.debug('error', err.body.userMessage)
        this.props.notification(err.body && (err.body.userMessage || err.body.developerMessage || 'Error'), 'error')
        throw err
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            checkEmail={this.handleCheckEmail}
            createLeader={this.handleLeaderCreate}
          />
        )
      }
    }
    return Leaders
  }
}

export default decorator
